// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@400;500;600;700;800&family=IBM+Plex+Mono:wght@400;500;600;700&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  font-family: "Plus Jakarta Sans", system-ui, -apple-system, sans-serif;
  color: #0f1b2a;
  background: #f4f7fa;
  -webkit-font-smoothing: antialiased;
}

/* Was: font-family: "Inter", sans-serif !important — that overrode every
   inline font in the restyle (including IBM Plex Mono on numbers/IDs).
   Elements now inherit the body font; inline fontFamily wins where set. */
* {
  box-sizing: border-box;
}

button,
input,
select,
textarea {
  font-family: inherit;
}

a {
  text-decoration: none;
  color: #0b5c8a;
}

a:hover {
  color: #084767;
}

@media (max-width: 750px) {
  h4 {
    font-size: 26px !important;
  }
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAEA;EACE,sEAAsE;EACtE,cAAc;EACd,mBAAmB;EACnB,mCAAmC;AACrC;;AAEA;;0EAE0E;AAC1E;EACE,sBAAsB;AACxB;;AAEA;;;;EAIE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF","sourcesContent":["@import url(\"https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@400;500;600;700;800&family=IBM+Plex+Mono:wght@400;500;600;700&display=swap\");\n\nbody {\n  font-family: \"Plus Jakarta Sans\", system-ui, -apple-system, sans-serif;\n  color: #0f1b2a;\n  background: #f4f7fa;\n  -webkit-font-smoothing: antialiased;\n}\n\n/* Was: font-family: \"Inter\", sans-serif !important — that overrode every\n   inline font in the restyle (including IBM Plex Mono on numbers/IDs).\n   Elements now inherit the body font; inline fontFamily wins where set. */\n* {\n  box-sizing: border-box;\n}\n\nbutton,\ninput,\nselect,\ntextarea {\n  font-family: inherit;\n}\n\na {\n  text-decoration: none;\n  color: #0b5c8a;\n}\n\na:hover {\n  color: #084767;\n}\n\n@media (max-width: 750px) {\n  h4 {\n    font-size: 26px !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
